module.exports = __webpack_public_path__ + "img/ddwu_gallery9.e6622601.jpg";